export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 rounded-2xl bg-background-800 overflow-hidden">
          <div className="flex-1 p-8 md:p-12 lg:p-14">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-background-50">
              移动观影
            </h2>
            <p className="mt-3 text-sm text-background-300 leading-relaxed max-w-[480px]">
              91免费视频网站全面适配移动端浏览器，无需下载任何APP，打开即可畅享91国产免费视频与91传媒视频在线资源，手机观影同样高清流畅。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-background-700/50 border border-background-600/30 text-background-200 text-sm whitespace-nowrap">
                <i className="ri-android-line text-lg w-5 h-5 flex items-center justify-center"></i>
                Android 浏览器
              </div>
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-background-700/50 border border-background-600/30 text-background-200 text-sm whitespace-nowrap">
                <i className="ri-apple-line text-lg w-5 h-5 flex items-center justify-center"></i>
                iOS Safari
              </div>
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-background-700/50 border border-background-600/30 text-background-200 text-sm whitespace-nowrap">
                <i className="ri-computer-line text-lg w-5 h-5 flex items-center justify-center"></i>
                桌面浏览器
              </div>
            </div>
          </div>
          <div className="flex-1 flex justify-center lg:justify-end p-6 md:p-8">
            <div className="relative w-[220px] h-[380px] rounded-2xl overflow-hidden border-4 border-background-600/40 bg-background-900">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20showing%20a%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%20in%20a%20grid%20layout%2C%20dark%20theme%2C%20warm%20red%20accents%2C%20clean%20modern%20UI%2C%20video%20player%20elements%2C%20no%20actual%20faces%2C%20abstract%20cinematic%20design%2C%20minimalist%20mobile%20screen%20mockup%20on%20transparent%20background&width=440&height=760&seq=app-mockup-2026&orientation=portrait"
                alt="91免费视频网站移动端观影界面"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}